/**
 * @param preferenceCenter
 * @param onSubmit {(form: HTMLFormElement) => void}
 * @return {void}
 */
module.exports = function listenToPreferenceCenterFormSubmit(preferenceCenter, onSubmit) {
    preferenceCenter.querySelectorAll('form').forEach(form => {
        if (form instanceof HTMLFormElement) {
            form.addEventListener("submit", ev => {
                ev.preventDefault();
                onSubmit(form);
            });
        }
    });
}
